import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Tag, Input, Modal, Form, Button } from "antd";
import { EditOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useDebounce } from "../../../core/hooks/useDebounce";
import { addDevice, deleteDevice, fetchDevices, updateDevice } from "../../../core/data/redux/slices/AllDeviceSlice";
import { showToast } from "../../../core/data/redux/slices/ToastSlice";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import api from "../../../core/axios/axiosInstance";
import Select from "react-select";

const DevicesDetails = () => {
    const dispatch = useDispatch();
    const location = useLocation()
    const { devices, loading } = useSelector((state) => state.devices);
    const [companies, setCompanies] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalAdmins, setTotalAdmins] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [editingCompany, setEditingCompany] = useState(null);

    const [companyAdmins, setCompanyAdmins] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [loadingAdmins, setLoadingAdmins] = useState(false);

    const [assignForm] = Form.useForm();



    const deviceDetails =
        location.state?.record || {};
    console.log(deviceDetails, "khjgfcvjbk");

    const { confirm } = Modal;
    const [localSearch, setLocalSearch] = useState("");
    const debouncedSearch = useDebounce(localSearch, 500);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingDevice, setEditingDevice] = useState(null);
    const [form] = Form.useForm();
    const route = all_routes;
    const openAddModal = () => {
        setEditingDevice(null);
        form.resetFields();
        setIsModalOpen(true);
    };

    useEffect(() => {
        const fetchAllCompanyAdmins = async () => {
            try {
                setLoadingAdmins(true);

                const response = await api.post(
                    "superAdmin/allCompanyAdmin",
                    {
                        page: 1,
                        limit: 2000,
                        search: ""
                    }
                );

                const options = response.data.data.map((admin) => ({
                    value: admin._id, // THIS IS userId
                    label: `${admin.firstname || ""} ${admin.lastname || ""}`.trim() || admin.email,
                    email: admin.email,
                    companyName: admin.userInfo?.companyName || "No Company",
                    raw: admin
                }));

                setCompanyAdmins(options);
            } catch (error) {
                console.error(error);
            } finally {
                setLoadingAdmins(false);
            }
        };

        fetchAllCompanyAdmins();
    }, []);


    const formatOptionLabel = ({ label, email, companyName }) => (
        <div>
            <div style={{ fontWeight: 600 }}>
                {label} <span style={{ color: "#888" }}>({companyName})</span>
            </div>
            <div style={{ fontSize: 12, color: "#666" }}>{email}</div>
        </div>
    );
    const openAddCompany = () => {
        setEditingCompany(null);
        setSelectedAdmin(null);
        assignForm.resetFields();
        setIsAssignModalOpen(true);
    };

    const fetchCompanyByDeviceId = async () => {
        try {
            const payload = {
                deviceId: deviceDetails.deviceId,
                page,
                limit,
                search: debouncedSearch || ""
            };

            const response = await api.post(
                "superAdmin/getAllCompanyAdminsByPBXDevice",
                payload
            );
console.log(response.data,"response from getAllCompanyAdminsByPBXDevice");

            setCompanies(response.data.data || []);
            setTotalAdmins(response.data.totalAdmins);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (!deviceDetails?.deviceId) return;

        fetchCompanyByDeviceId();
    }, [deviceDetails?.deviceId, page, limit, debouncedSearch]);


    const openEditCompany = (record) => {
        setEditingCompany(record);

        // find admin from dropdown options
        const adminOption = companyAdmins.find(
            (opt) => opt.value === record._id
        );

        setSelectedAdmin(adminOption || null);

        assignForm.setFieldsValue({
            PBX_EXTENSION_NUMBER: record.PBXDetails?.PBX_EXTENSION_NUMBER,
            PBX_EXTENSION_ID: record.PBXDetails?.PBX_EXTENSION_ID,
            PBX_SIP_SECRET: record.PBXDetails?.PBX_SIP_SECRET,
            PBX_TELEPHONE: record.PBXDetails?.PBX_TELEPHONE
        });

        setIsAssignModalOpen(true);
    };




    const handleDeleteDevice = (deviceId) => {
        confirm({
            title: "Are you sure you want to delete this device?",
            icon: <ExclamationCircleOutlined />,
            content: "This action cannot be undone.",
            okText: "Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk: async () => {
                try {
                    console.log(deviceId, "kjhgfchvjb");

                    await dispatch(deleteDevice(deviceId)).unwrap();
                } catch (error) {
                    dispatch(
                        showToast({
                            heading: "Error",
                            message: error || "Failed to delete device",
                            variant: "danger",
                        })
                    );
                }
            },
            onCancel() {
                // Optional: do something on cancel
            },
        });
    };
    const openEditModal = (device) => {
        setEditingDevice(device);
        form.setFieldsValue({
            PBX_BASE_URL: device.PBX_BASE_URL,
            PBX_USERNAME: device.PBX_USERNAME,
            PBX_PASSWORD: device.PBX_PASSWORD,
            PBX_SDK_ACCESS_ID: device.PBX_SDK_ACCESS_ID,
            PBX_SDK_ACCESS_KEY: device.PBX_SDK_ACCESS_KEY,
            deviceName: device.deviceName,
            PBX_USER_AGENT: device.PBX_USER_AGENT || "",
            isActive: device.isActive,
            deviceId: device.deviceId || ""
        });
        setIsModalOpen(true);
    };
 

    useEffect(() => {
        dispatch(fetchDevices());
    }, [dispatch]);

    const filteredDevices = devices?.filter((d) =>
        d.deviceName?.toLowerCase().includes(debouncedSearch.toLowerCase())
    );


    const companyColumns = [
        {
            title: "Name",
            key: "name",
            render: (_, record) => (
                <strong>{record.firstname} {record.lastname}</strong>
            )
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email"
        },
        {
            title: "Phone Numbers",
            key: "phone",
            render: (_, record) =>
                record.phonenumbers?.map(p => `+${p.countryCode} ${p.number}`).join(", ")
        },
        {
            title: "PBX Telephone",
            dataIndex: "telephone",
             key: "telephone"
        },
        // {
        //     title: "Actions",
        //     key: "actions",
        //     render: (_, record) => (
        //         <Button
        //             type="link"
        //             icon={<EditOutlined />}
        //             onClick={() => openEditCompany(record)}
        //         >
        //             Edit
        //         </Button>
        //     )
        // }
    ];

    const handleAssignCompany = async (values) => {
        try {
            if (!selectedAdmin?.value && !editingCompany) {
                return;
            }

            const payload = {
                users: [
                    {
                        userId: editingCompany
                            ? editingCompany._id
                            : selectedAdmin.value,
                        deviceId: deviceDetails.deviceId,
                        ...values
                    }
                ]
            };

            await api.post(
                "/superAdmin/updateMultipleYeastarUsers",
                payload
            );

            setIsAssignModalOpen(false);
            assignForm.resetFields();
            setSelectedAdmin(null);
            fetchCompanyByDeviceId()
            setPage(1);
        } catch (error) {
            console.error(error);
        }
    };



    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="card">
                    <div className="card-body table-responsive custom-table">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="fw-semibold">
                                Company Admins ({totalAdmins})
                            </h5>

                            {/* <Button type="primary" onClick={openAddCompany}>
                                Assign New Company
                            </Button> */}
                        </div>

                        <Table
                            columns={companyColumns}
                            dataSource={companies}
                            rowKey="_id"
                            pagination={{
                                current: page,
                                pageSize: limit,
                                total: totalAdmins,
                                onChange: (p, l) => {
                                    setPage(p);
                                    setLimit(l);
                                }
                            }}
                            bordered
                        />

                    </div>
                </div>

                <Modal
                    open={isAssignModalOpen}
                    title={editingCompany ? "Edit Company PBX Details" : "Assign New Company"}
                    onCancel={() => setIsAssignModalOpen(false)}
                    onOk={() => assignForm.submit()}
                    okText={editingCompany ? "Update" : "Assign"}
                    destroyOnClose
                >
                    <Form form={assignForm} layout="vertical" onFinish={handleAssignCompany}>
                        <Form.Item label="Company Admin" required>
                            <Select
                                options={companyAdmins}
                                value={selectedAdmin}
                                onChange={setSelectedAdmin}
                                isLoading={loadingAdmins}
                                isSearchable
                                isDisabled={!!editingCompany}
                                placeholder="Search company admin..."
                                formatOptionLabel={formatOptionLabel}
                            />
                        </Form.Item>

                        <Form.Item
                            label="PBX Extension Number"
                            name="PBX_EXTENSION_NUMBER"
                            rules={[{ required: true }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="PBX Extension ID"
                            name="PBX_EXTENSION_ID"
                            rules={[{ required: true }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="PBX SIP Secret"
                            name="PBX_SIP_SECRET"
                            rules={[{ required: true }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            label="PBX Telephone"
                            name="PBX_TELEPHONE"
                            rules={[{ required: true }]}
                        >
                            <Input />
                        </Form.Item>
                    </Form>
                </Modal>

            </div>
        </div>
    );
};

export default DevicesDetails;